import React from "react";

import { IPanelProps, Panel } from "core/decorators/Panel";
import FFHTMLWidget from "./FFHTMLWidget";
import TokenSession from "core/util/session/TokenSession";
import HtmlDefault from "common/fragments/HtmlDefault";
import { BlockView } from "common/views/block/BlockView.view";
import { DialogView } from "common/views/dialog/Dialog.view";
import EntityForm from "core/components/EntityForm";
import { ButtonView } from "common/views/button/Button.view";
import Query from "core/api/QueryComponent";
import { ForumToaster } from "panels/forum/forumActions";
import { Intent } from "@blueprintjs/core";
import FFHTMLWidgetConfig from "./FFHTMLWidgetConfig";
export interface FFHTMLWidgetPanelState {
	isOpen: boolean; // for dialog edit view
	toggleOpen: boolean;
	mutationFlag: boolean; //get Toggles in-case of mutation to get each new graph-QL Request
}

@Panel({ id: "FFHTMLWidget", configClass: FFHTMLWidgetConfig })
export default class FFHTMLWidgetPanel extends React.Component<
	IPanelProps<FFHTMLWidgetConfig>,
	FFHTMLWidgetPanelState
> {
	private frameRef: any;
	private attributeToConvert = 'fftext';

	public state: FFHTMLWidgetPanelState = {
		isOpen: false,
		toggleOpen: false,
		mutationFlag: false
	};

	constructor(props: IPanelProps<FFHTMLWidgetConfig>) {
		super(props);
		this.frameRef = React.createRef();
	}
	private toggleOpen = () => this.setState({ isOpen: !this.state.isOpen });

	private showDialog = (data: FFHTMLWidget) => {
		if (this.state.isOpen) {
			return (
				<DialogView
					isOpen={this.state.isOpen}
					onClose={this.toggleOpen}
					viewKey="dialog"
				>
					<BlockView viewKey="card-primary">
						<EntityForm
							instance={data}
							clazz={FFHTMLWidget}
							afterSave={data => {
								ForumToaster.show({
									intent: Intent.SUCCESS,
									message: "Saved successfully !!"
								});
								this.setState(prev => ({
									isOpen: false,
									mutationFlag: !prev.mutationFlag
								}));
							}}
							config={{...this.props.config}}
							attributeToConvert={this.attributeToConvert}
						/>
					</BlockView>
				</DialogView>
			);
		} else {
			return null;
		}
	};

	public render() {
		return (
			<div>
				<Query.One
					entity={FFHTMLWidget}
					args={{
						id: this.props.instance,
						instance: this.props.instance,
						lang: this.props.language,
						mutationFlag: this.state.mutationFlag
					}}
				>
					{req => {
						return (
							<BlockView viewKey="card-primary">
								{TokenSession.hasRoles("ROLE_ADMIN") && (
									<div>
										{this.showDialog(req.data)}
										<ButtonView
											viewKey="edit.button"
											onClick={this.toggleOpen}
										/>
									</div>
								)}
								<HtmlDefault
									html={
										req.data
											? req.data.fftext
											: "<b>[]</b>"
									}
								/>
							</BlockView>
						);
					}}
				</Query.One>
			</div>
		);
	}
}



// WEBPACK FOOTER //
// ./src/panels/FFHTMLWidget/FFHTMLWidget.panel.tsx